module.exports = __webpack_public_path__ + "static/sui-table-colspan-efcfe3bf88caa0e25d3b3e978bfe9e82.png";